import { Component } from '@angular/core';

interface TickerItem {
    name: string;
    market: string;
    price: string;
}

const TICKER_ITEMS: TickerItem[] = [
    { name: 'Maize (White)', market: 'Mokolo | CM', price: '350 XAF/kg' },
    { name: 'Sorghum', market: 'Garoua | CM', price: '280 XAF/kg' },
    { name: 'Rice (Local)', market: 'Yaoundé | CM', price: '650 XAF/kg' },
    { name: 'Cassava (Fresh)', market: 'Yaoundé | CM', price: '220 XAF/kg' },
    { name: 'Cassava Flour', market: 'Yaoundé | CM', price: '480 XAF/kg' },
    { name: 'Yam', market: 'Yaoundé | CM', price: '450 XAF/kg' },
    { name: 'Irish Potato', market: 'Bafoussam | CM', price: '480 XAF/kg' },
    { name: 'Plantain (Green)', market: 'Yaoundé | CM', price: '2 200 XAF/bunch' },
    { name: 'Banana', market: 'Yaoundé | CM', price: '1 200 XAF/bunch' },
    { name: 'Avocado', market: 'Bafoussam | CM', price: '1 500 XAF/kg' },
    { name: 'Mango', market: 'Sandaga | CM', price: '530 XAF/kg' },
    { name: 'Cocoa Beans', market: 'Yaoundé | CM', price: '2 134 XAF/kg' },
    { name: 'Coffee (Arabica)', market: 'Bafoussam | CM', price: '4 238 XAF/kg' },
    { name: 'Penja White Pepper', market: 'Sandaga | CM', price: '9 350 XAF/kg' },
    { name: 'Bitter Cola', market: 'Sandaga | CM', price: '9 800 XAF/kg' },
    { name: 'Cowpea (Black-eye)', market: 'Yaoundé | CM', price: '1 050 XAF/kg' },
    { name: 'Chicken (Live)', market: 'Sandaga | CM', price: '4 100 XAF/kg' },
    { name: 'Chebe Oil', market: 'New Bell | CM', price: '13 000 XAF/litre' },
    { name: 'Cabbage', market: 'Bafoussam | CM', price: '600 XAF/kg' },
    { name: 'Pepper (Hot)', market: 'Bafoussam | CM', price: '2 063 XAF/kg' },
    { name: 'Cayenne Pepper', market: 'Yaoundé | CM', price: '2 750 XAF/kg' },
    { name: 'Organic Bell Pepper', market: 'Sandaga | CM', price: '4 667 XAF/kg' },
    { name: 'Ginger', market: 'Mboppi | CM', price: '2 250 XAF/kg' },
];

@Component({
    selector: 'app-market-prices-ticker',
    template: `
        <div class="ticker-wrapper">
            <div class="ticker-label">Market Prices</div>
            <div class="ticker-track-wrapper">
                <div class="ticker-track">
                    <ng-container *ngFor="let item of tickerItems; let i = index">
                        <span class="ticker-item">
                            <span class="ticker-name">{{ item.name }}</span>
                            <span class="ticker-market">({{ item.market }})</span>
                            <span class="ticker-price">{{ item.price }}</span>
                        </span>
                        <span class="ticker-divider">|</span>
                    </ng-container>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./market-prices-ticker.component.css'],
    standalone: false
})
export class MarketPricesTickerComponent {
    tickerItems: TickerItem[] = [...TICKER_ITEMS, ...TICKER_ITEMS];
}
